import { DashboardHeader } from '@modules/admin/Admin.Header'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import { history as browserHistory } from '@services/History'
import AccessControl from '../../auth/AccessControl'
import CustomModal from '../../core/components/CustomModalComponent'

class AdministratorShow extends Component {
  administratorsClient = Consultations.administrators

  state = {
    id: this.props.match.params.id,
    deleteModal: false,
    administrator: undefined,
  }

  handleToggleModal = () => {
    this.setState((prevState) => ({ deleteModal: !prevState.deleteModal }))
  }

  handleDelete = () => {
    this.administratorsClient
      .delete(this.state.id)
      .then(() => browserHistory.push('/administrator'))
      .catch((err) => window.alert(err.message))
  }

  componentDidMount() {
    this.administratorsClient
      .show(this.state.id)
      .then((res) => this.setState({ administrator: res.data }))
      .catch((err) => window.alert(err.message))
  }

  render() {
    const { administrator } = this.state
    if (!administrator) return null

    return (
      <div>
        <DashboardHeader title={<Trans>Administrador</Trans>}>
          <AccessControl requiredPermission="administrators.manage">
            <Link className="btn btn-primary" to={`/administrator/update/${administrator.id}`}>
              <Trans>Editar</Trans>
            </Link>
            <button className="btn btn-danger" onClick={() => this.handleToggleModal(this.state.deleteModal)}>
              <Trans>Borrar</Trans>
            </button>
            <Link className="btn btn-primary" to={`/administrator`}>
              <Trans>Volver</Trans>
            </Link>
          </AccessControl>
        </DashboardHeader>

        {this.state.deleteModal && (
          <CustomModal
            title={<Trans>¿Estás seguro que quieres borrar este registro?</Trans>}
            active={this.state.deleteModal}
            actionOnClickClose={(active) => this.handleToggleModal(active)}
            actionOnClickAccept={(active) => this.handleDelete(active)}
          />
        )}

        <div className="container-fluid main-content">
          <div className="form-crud well">
            <div className="form-group">
              <label>
                <Trans>Nombre</Trans>
              </label>
              <span>{administrator.name}</span>
            </div>
            <div className="form-group">
              <label>
                <Trans>Email</Trans>
              </label>
              <span>{administrator.email}</span>
            </div>
            <div className="form-group">
              <label>
                <Trans>Teléfono</Trans>
              </label>
              <span>{administrator.phone}</span>
            </div>
            <div className="form-group">
              <label>
                <Trans>Avatar</Trans>
              </label>
              <img style={{ maxWidth: '100%' }} src={administrator.avatar} alt="adminAvatar" />
            </div>

            <div className="form-group">
              <label>
                <Trans>Tipo Administrador</Trans>
              </label>
              <span>{administrator.type}</span>
            </div>

            {administrator.company && (
              <div className="form-group">
                <label>
                  <Trans>Compañía</Trans>
                </label>
                <span>{administrator.company.name}</span>
              </div>
            )}
            {administrator.provider && (
              <div className="form-group">
                <label>
                  <Trans>Proveedor</Trans>
                </label>
                <span>{administrator.provider.name}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(AdministratorShow)
